import React from 'react';
import styled, { css } from 'styled-components';

import Progress from '@material-ui/core/CircularProgress';
import { Fade } from '@material-ui/core';
import Text from '../Text';

const Aligned = styled.div`
  ${({ aligned }) =>
    aligned &&
    css`
      width: 100%;
      height: calc(100vh - 88px);
      display: grid;
      place-items: center;
      z-index: 2;
      background-color: ${({ theme }) => theme.colors.gray200};
    `}
  ${({ fixed }) =>
    fixed &&
    css`
      position: fixed;
      height: 100vh;
    `}
`;

const LoadingText = styled(Text).attrs({ element: 'p' })`
  color: ${({ theme }) => theme.colors.gbrand500};
`;

const CircularProgress = styled(Progress)`
  margin-left: 10px;
  color: ${({ theme }) => theme.colors.gbrand500};
  background-color: transparent;
  svg {
    color: ${({ theme }) => theme.colors.gbrand500};
  }
`;

export const Spinner = ({ style, aligned, fixed, isLoading = true }) => (
  <Fade in={isLoading} id="fade-spinner">
    <Aligned aligned={aligned} fixed={fixed} style={style}>
      <div>
        <CircularProgress />
        <LoadingText id="p-spinner">Cargando</LoadingText>
      </div>
    </Aligned>
  </Fade>
);
